import LogoImage from "assets/logo-black.png";
import styles from "./styles.module.scss";

const link = "https://treegress.com/";

const Logo = () => {
  return (
    <a
      className={styles.container}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img className={styles.img} src={LogoImage} alt={"Treegress Logo"} />
    </a>
  );
};

export default Logo;
